import { render, staticRenderFns } from "./joinCall.vue?vue&type=template&id=3177189b&"
import script from "./joinCall.vue?vue&type=script&lang=js&"
export * from "./joinCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports